export const formControlChromeClassName =
  "h-8 rounded-[var(--radius-button)] border border-[color:var(--rule-line)] bg-[var(--bg-input)] dark:bg-[var(--bg-input)]";
